export default __webpack_public_path__ + "static/logo-t-5dadd7dad8a04dd525d3ffa60ab661f4.svg";